import { ActionItemStateByKey, ActionItemStatus } from '@uplift/api';
import { CamelCaseKeys } from '@uplift/types';

export enum OnboardingSteps {
  ToDo = 'todo',
  InReview = 'inReview',
  Approved = 'approved',
  Live = 'live',
}

export type ItemWithStatus = {
  status?: ActionItemStatus;
};

export type TodoItem = {
  task: string;
  status: ActionItemStatus;
};

export type OnboardingItems = {
  todoItems: TodoItem[];
  progressSummaryItems: TodoItem[];
  progressPercentage: number;
};

export type TodoItems = CamelCaseKeys<ActionItemStateByKey>;
export type ItemsKey = keyof TodoItems;
